<template>
  <div class="full-width" id="ss-mazda-seo-content">
    <div class="dark-overlay section-space-lg">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-8">
            <h4>About Our Dealership</h4>
            <h1>Hometown Mazda in Raleigh</h1>
            <h3>Serving Durham & Chapel Hill, NC</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-8 col-md-7">
            <p>At Hometown Mazda, building a relationship is our priority. Our highly-trained professionals are dedicated to fulfilling the needs and exceeding the expectations of our loyal customers. A newly renovated dealership, Hometown Mazda in Raleigh, NC showcases the most comprehensive and generous lineup of the latest Mazda <a href="#">models</a>. Whether you’re searching for new, used or certified pre-owned vehicles, our large selection covers it all. When shopping for your next vehicle, Hometown Mazda welcomes residents of Raleigh, Durham, and Chapel Hill to stop by our location at <a href="#">123 Main Street</a>. Your dream Mazda is waiting for you!</p>
            <div class="collapse" id="ss-mazda-read-more">
              <h3>New, Used & Certified Pre-Owned Mazda Vehicles in Raleigh, NC</h3>
              <p>Hometown Mazda is proud to display the most sought-after models of the moment including the <a href="#">Mazda3</a>, <a href="#">Mazda6</a>, <a href="#">Mazda CX-5</a>, <a href="#">Mazda CX-9</a>, and <a href="#">Mazda MX-5 Miata</a>. As we constantly update our inventory, our customers can count on the most accurate <a href="#">options</a> and pricing available. If you’re looking to stick to a tight budget, then the <a href="#">used</a> and <a href="#">Certified Pre-Owned</a> inventory at Hometown Mazda is going to leave you speechless. Be sure to view our <a href="#">new</a> and <a href="#">pre-owned</a> specials to help you save on your next purchase or lease. </p>
              <h3>North Carolina Mazda Auto Financing & Auto Lease Deals</h3>
              <p> Our Finance consultants here at Hometown Mazda want to make sure you get the car you want at the price you want. Our financing team can secure you an affordable loan or lease option for your new or used car. Our online <a href="#">Finance Application</a> makes it easy to apply now and quickly get an idea of the car financing options currently available. Check out our <a href="#">Finance Information</a> to learn more information. </p>
              <h3>Affordable and Reliable Mazda Service & Parts in the Triangle Area</h3>
              <p>Getting your Mazda serviced has never been easier. If you need any type of service from a simple lube, oil and filter change, tire rotation, front end alignment, routine scheduled maintenance or more extensive maintenance like a Mazda transmission and engine repair, we have a team of certified technicians to service your car. Our website allows you to set up a <a href="#">Service Appointment</a> that fits your busy schedule. Hometown Mazda’s trained technicians use genuine parts that were specifically designed for your vehicle. We are committed to providing you with quick, efficient, and competitively priced service and parts. Come see what our customers have discovered and come to depend on. You can also check out our <a href="#">Service Specials</a> and <a href="#">Parts Specials</a> to save. Give us a call at (919) 555-5555. </p>
            </div>
            <a class="more-link">Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    mounted() {
      $('#ss-mazda-read-more').on('show.bs.collapse', function () {
        $( "#ss-mazda-seo-content .more-link").html('Read Less');
      });
      $('#ss-mazda-read-more').on('hide.bs.collapse', function () {
        $( "#ss-mazda-seo-content .more-link").html('Read More');
      });
      $( "#ss-mazda-seo-content .more-link" ).click(function() {
    $( "#ss-mazda-seo-content .collapse" ).slideToggle();
      var $this = $(this);
      $this.toggleClass("open");
      if ($this.hasClass("open")) {
        $this.html('Read Less');
      } else {
        $this.html('Read More');
      }
    });
    }
  };
  </script>
  
  <style
    scoped
    src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
  ></style>

  <style scoped>
  #ss-mazda-seo-content {
    background-image: url("../../static/images/mazda-dark-overlay-image-01.jpeg");
    font-size: 14px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    font-family: Mazda-Regular, Arial, sans-serif !important;
    line-height: 1.428571429;
  }
  #ss-mazda-seo-content .dark-overlay {
    background: linear-gradient(to left, rgba(0, 0, 0, 0.3), #000);
    color: #fff;
  }
  #ss-mazda-seo-content .section-space-lg {
    padding-top: calc(8% + 30px);
    padding-bottom: calc(8% + 30px);
  }
  #ss-mazda-seo-content .dark-overlay h1, #ss-mazda-seo-content .dark-overlay h2, #ss-mazda-seo-content .dark-overlay h3 {
    color: #fff;
  }
  #ss-mazda-seo-content h1, 
  #ss-mazda-seo-content h2, 
  #ss-mazda-seo-content h3, 
  #ss-mazda-seo-content h4, 
  #ss-mazda-seo-content h5, 
  #ss-mazda-seo-content h6 {
    text-transform: uppercase;
    letter-spacing: 2px;
    font-family: Mazda-Regular, Arial, sans-serif !important;
    line-height: 1.1;
  }
  #ss-mazda-seo-content .dark-overlay h1 {
    font-size: 2.2rem;
  }
  #ss-mazda-seo-content .dark-overlay h3 {
    font-size: 1.2rem;
  }
  #ss-mazda-seo-content .dark-overlay h4 {
    font-size: 1rem;
  }
  #ss-mazda-seo-content .dark-overlay p a {
    font-weight: bold;
    color: #d5d5d5;
  }
  #ss-mazda-seo-content .more-link {
    color: #999;
    border-bottom: solid 2px #999;
    border-radius: 0 !important;
    padding-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: bold;
    cursor: pointer;
    text-decoration: none !important;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }
  #ss-mazda-seo-content .more-link:hover {
    color: #f5f5f5;
    border-bottom-color: #f5f5f5;
  }

  @media (max-width: 991px) {
    #ss-mazda-seo-content .dark-overlay h1 {
      font-size: 2.125rem;
    }
  }
</style>
